import * as types from '../constants/ActionTypes';

const initialState = {
  isLoading: false,
  error: false,
  display: false,
  topicName: '',
  fields: [],
};

/**
 * `setFieldsDetail` helps to create the new array with customized Field Structure.
 * @param {String} fieldPrefix  This is Topic Id which is last selected.
 * @param {Array} fieldsDetial This Custom Object hold the required field details.
 */
function setFieldsDetail(fieldPrefix, fieldsDetial) {
  const fields = fieldsDetial.map((field, index) => {
    const fieldType = `${field.type || 'unnamed-type'}`;
    const fieldId = field.id || `${fieldType}-${fieldPrefix}-${index + 1}`;

    const fieldInfo = {
      id: fieldId,
      type: field.type,
      label: field.default_text,
      name: field.default_text || field.type,
      isRequired: (field.required),
      value: '',
      hasError: (field.required),
    };

    if (field.character_limit) {
      fieldInfo.limit = field.character_limit;
    }

    if (field.options) {
      fieldInfo.options = field.options.map(value => ({
        value,
        label: value,
      }));
    }

    if (field.link_src) {
      fieldInfo.href = field.link_src;
    }

    if (field.title) {
      fieldInfo.title = field.title;
    }

    return fieldInfo;
  });
  return fields;
}

export default function (state = initialState, action) {
  switch (action.type) {
    case types.SELECT_TOPIC_L1:
      return Object.assign({}, state, { topicName: action.payload.topic_name });
    case types.SELECT_TOPIC_L2:
      return Object.assign({}, state, { topicName: state.topicName, subTopicName: action.payload.topic_name, fieldPrefix: action.payload.topic_id, fields: [] });
    case types.SELECT_TOPIC_L3:
      return Object.assign({}, state, {
        topicName: state.subTopicName,
        subTopicName: action.payload.topicName,
        fieldPrefix: action.payload.topicId,
        fields: [],
      });
    case types.REQUEST_TOPIC_DATA:
      return Object.assign({}, state, { isLoading: true });
    case types.RECEIVE_TOPIC_DATA_ERROR:
    case types.RECEIVE_EMPTY_FIELDS:
    case types.RECEIVE_EMAIL_ERROR:
      return Object.assign({}, state, { isLoading: false, error: true, display: false });
    case types.RECEIVE_FORM_FIELDS:
      return Object.assign({}, state, {
        isLoading: false,
        kanaCode: action.payload.kanaCode,
        fields: setFieldsDetail(state.fieldPrefix, action.payload.formFields),
        error: false,
        display: false,
        topicRefId: action.payload.topicRefId,
      });
    case types.REQUEST_BY_EMAIL:
      return Object.assign({}, state, { display: true });
    case types.PRESERVE_FIELD_DATA:
      return Object.assign({}, state, { fields: action.payload });
    case types.CHANGE_TOPIC:
    case types.CANCEL_EMAIL_FORM:
    case types.RECEIVE_EMAIL_RESPONSE:
    case types.LOGIN_EMAIL :
      return Object.assign({}, state, { display: false });
    default:
      return state;
  }
}
